<template>
    <b-toast
        :auto-hide-delay="autoHideDelay"
        :no-auto-hide="noAutoHide"
        :no-close-button="noCloseButton"
        :solid="solid"
        :title="title"
        :toaster="toaster"
        :variant="color"
        :visible="value"
        @change="$emit('input', $event)"
    >
        <slot />
    </b-toast>
</template>

<script>
import { BToast } from 'bootstrap-vue'

export default {
    components: { BToast },
    props: {
        autoHideDelay: { type: Number, default: 5000 },
        color: { type: String, default: 'default' },
        noAutoHide: { type: Boolean, default: false },
        noCloseButton: { type: Boolean, default: false },
        solid: { type: Boolean, default: false },
        title: { type: String },
        toaster: { type: String, default: 'b-toaster-bottom-right' },
        value: { type: Boolean, default: false },
    },
}
</script>
